// @flow
import CopyMenuFromToOrgs from './CopyMenuFromToOrgs';

export default CopyMenuFromToOrgs;
